module.exports = __webpack_public_path__ + "static/media/drawing_copy.30d34a3e.png";